const connectifService = {
  _state: 'DISABLED',
  _processingQueue: false,
  queue: new Proxy([], {
    set: (target: any, property: any, value) => {
      target[property] = value
      if (property === 'length' && !connectifService._processingQueue) {
        connectifService._processQueue()
      }
      return true
    },
  }),
  _processQueue() {
    if (connectifService._state === 'ENABLED') {
      connectifService._processingQueue = true
      while (this.queue.length) {
        const ev = this.queue.shift()
        window.connectif.managed.sendEvents([ev])
      }
      connectifService._processingQueue = false
    } else if (connectifService._state === 'DISABLED') {
      connectifService._state = 'LOADING'
      const onInitialized = () => {
        connectifService._state = 'ENABLED'
        connectifService._processQueue()
        document.removeEventListener(
          'connectif.managed.initialized',
          onInitialized,
        )
        window.removeEventListener('pagehide', removeListener)
      }
      const removeListener = () => {
        document.removeEventListener(
          'connectif.managed.initialized',
          onInitialized,
        )
        window.removeEventListener('pagehide', removeListener)
      }
      document.addEventListener('connectif.managed.initialized', onInitialized)
      window.addEventListener('pagehide', removeListener, { once: true })
    }
  },
  send: (params: any) => {
    connectifService.queue.push(params)
  },
}

export default connectifService
